// extracted by mini-css-extract-plugin
export default {"principal_cont":"Principal_principal_cont__k+Mdr","principal_grid":"Principal_principal_grid__ntwYx","principal_grid1":"Principal_principal_grid1__nf+RM"};